import { getSelectedElements, isSomeElementSelected } from "../scene";
import { KEYS } from "../keys";
import { ToolButton } from "../components/ToolButton";
import { t } from "../i18n";
import { register } from "./register";
import {getNonDeletedElements, isTextElement} from "../element";
import { ExcalidrawElement } from "../element/types";
import { AppState } from "../types";
import {mutateElement, newElementWith} from "../element/mutateElement";
import { getElementsInGroup } from "../groups";
import { LinearElementEditor } from "../element/linearElementEditor";
import { fixBindingsAfterDeletion,getBindingUpdatesAfterDeletion } from "../element/binding";
import {
  isBoundToContainer,
  isFrameLikeElement,
  isImageElement,
  isLinearElementType,
  isMindmapElement, isStickyNotesElement
} from "../element/typeChecks";
import { updateActiveTool } from "../utils";
import { TrashIcon } from "../components/icons";
import {postMessage} from "../../../../src/common/event";
import {
  EVENT_ELEMENT_DELETE,
  EVENT_ELEMENT_DELETE_FROM_ACTION,
  EVENT_UPDATE_FRAME_LIST,
  KEY_FILE_DIR
} from "../../../../src/Const";
import {extFromMineType, isNoteElement} from "../../../../src/utils";
import {
  deleteTiptapDoc,
  getCardById,
  getNoteDocList,
  getNoteJsonDoc,
  getNoteList,
  hasInOtherProject
} from "../../../../model";
import {ipcInvoke, ipcSend} from "../../../../src/common/ipc";
import {PROJECT_ID} from "../../../../src/views/Draw/DrawIndex";
import {loopAllNode} from "../../../../src/TreeUtils";
import {imgServer} from "../../../../src/components/EditorV2/imgServer";

const deleteSelectedElements = (
  elements: readonly ExcalidrawElement[],
  appState: AppState,
  app:any
) => {

  const framesToBeDeleted = new Set(
    getSelectedElements(
      elements.filter((el) => isFrameLikeElement(el)),
      appState,
    ).map((el) => el.id),
  );

  const filterSelectedElementIds = elements
      .filter((el) => appState.selectedElementIds[el.id])
      .reduce((prev, el) => {
        const boundElements = el.boundElements || [];
        const boundElementIds = boundElements.map(
            (boundElement) => boundElement.id,
        );
        prev.push(el.id, ...boundElementIds);
        return prev;
      }, [] as string[]);

  //刷新.....
  const arrayNoteIds:any = [];

  for (let i=0;i<elements.length;i++){
    let ele:any = appState.selectedElementIds[elements[i].id];
    if (!ele)continue;

    ele = elements[i];
    if (ele && isNoteElement(elements[i])){
      arrayNoteIds.push(elements[i].customData.generationData.id);
    }

    //如果删除的是图片，并且不在库里面，那么把这个文件也删了.
    if (ele && isImageElement(elements[i])){
      getCardById(elements[i].customData?.generationData?.id || elements[i].id).then(res=>{
        if (!res){
          const file = app.files[elements[i].fileId];
          const szFileName = file.id + '.' + extFromMineType(file.mimeType);
          const szFileName1 = elements[i].customData?.generationData?.originName + '.jpg';
          let szFullPath = file.fullPath;
          //判断别的项目里面是否有这个图...
          // getNoteDocList().then(arrayDocs=>{
          //   const hasInOther = hasInOtherProject(arrayDocs,PROJECT_ID,file.id);
          //   if (!hasInOther){
          //     ipcInvoke('delete-files-file',{fileName:szFileName})
          //   }
          // })

          //检测这个图片是否在别的项目里面--
          getNoteList(0).then(async (res:any)=>{
            let imgRefCount = 0;
            for (let i=0;i<res.length;i++){
              // if (res[i].id == PROJECT_ID)continue;
              const projectDoc = await getNoteJsonDoc(res[i].id);
              if (projectDoc){
                loopAllNode(projectDoc.canvas,(canvas)=>{
                  if (imgRefCount < 2 && canvas.drawJson?.files){
                    // if (canvas.drawJson.files[file.id] || canvas.drawJson.elements.some(p=>p.fileId == file.id)){
                    //   imgRefCount++
                    // }
                    imgRefCount += canvas.drawJson.elements.filter(p=>p.fileId == file.id).length;
                  }
                })
              }
              if (imgRefCount > 1){
                break;
              }
            }
            if (imgRefCount <= 1){
              ipcInvoke('delete-files-file',{fileName:szFileName})
              ipcInvoke('delete-files-file',{fileName:szFileName1});
              if (szFullPath && szFullPath.startsWith(localStorage.getItem(KEY_FILE_DIR))){
                ipcInvoke('delete-files-file',{fileName:szFullPath,isAbsolutePath:true});
              }
            }
          })
        }
      })
    }else if (isTextElement(ele) || isStickyNotesElement(ele)){
      //从单独的表中删除
      deleteTiptapDoc(ele.id);
      //是文本或者sticknotes取内容并把里面所有的图片全部删了。。。。
      const arrayImgs = imgServer.getImageListFromHtml(ele.value);
      for (let i=0;i<arrayImgs.length;i++){
        //全部删
        ipcInvoke('delete-files-file',{fileName:arrayImgs[i].fileName});
      }

    }
  }

  postMessage(EVENT_ELEMENT_DELETE,{arrayNoteIds:arrayNoteIds});
  postMessage(EVENT_ELEMENT_DELETE_FROM_ACTION);
  if (framesToBeDeleted.size > 0){
    setTimeout(()=>{
      postMessage(EVENT_UPDATE_FRAME_LIST);
    },100)
  }

  return {
    elements: elements.map((el) => {
      if (filterSelectedElementIds.includes(el.id)) {
        return newElementWith(el, { isDeleted: true });
      }

      // if (el.frameId && framesToBeDeleted.has(el.frameId)) {
      //   return newElementWith(el, { isDeleted: true });
      // }
      if (el.frameId && framesToBeDeleted.has(el.frameId)) {
        return newElementWith(el, { frameId: null });
      }

      if (
        isBoundToContainer(el) &&
        appState.selectedElementIds[el.containerId]
      ) {
        return newElementWith(el, { isDeleted: true });
      }
      return el;
    }),
    appState: {
      ...appState,
      selectedElementIds: {},
      selectedGroupIds: {},
    },
  };
};

const handleGroupEditingState = (
  appState: AppState,
  elements: readonly ExcalidrawElement[],
): AppState => {
  if (appState.editingGroupId) {
    const siblingElements = getElementsInGroup(
      getNonDeletedElements(elements),
      appState.editingGroupId!,
    );
    if (siblingElements.length) {
      return {
        ...appState,
        selectedElementIds: { [siblingElements[0].id]: true },
      };
    }
  }
  return appState;
};

export const actionDeleteSelected = register({
  name: "deleteSelectedElements",
  trackEvent: { category: "element", action: "delete" },
  perform: (elements, appState,formData,app) => {
    if (appState.mindmapOperations?.status === "init") {
      const selectedElements = getSelectedElements(
          getNonDeletedElements(elements),
          appState,
      );

      const mindmapElement = selectedElements.filter((el) =>
          isMindmapElement(el),
      );

      if (mindmapElement.length) {
        const event = new KeyboardEvent("keydown", {
          key: KEYS.DELETE,
          code: KEYS.DELETE,
          bubbles: true, // 事件是否冒泡
          cancelable: true, // 事件是否可以被取消
        });
        // @ts-ignore
        event.isActiveNodeRoot = true;
        document
            .getElementsByClassName("excalidraw-container")?.[0]
            ?.dispatchEvent(event);

        return {
          appState: {
            ...appState,
            mindmapOperations: {
              deletingElements: mindmapElement.map((e) => e.id),
              status: "init",
            },
          },
          commitToHistory: false,
        };
      }
    }

    if (appState.editingLinearElement) {
      const {
        elementId,
        selectedPointsIndices,
        startBindingElement,
        endBindingElement,
      } = appState.editingLinearElement;
      const element = LinearElementEditor.getElement(elementId);
      if (!element) {
        return false;
      }
      // case: no point selected → do nothing, as deleting the whole element
      // is most likely a mistake, where you wanted to delete a specific point
      // but failed to select it (or you thought it's selected, while it was
      // only in a hover state)
      if (selectedPointsIndices == null) {
        return false;
      }

      // case: deleting last remaining point
      if (element.points.length < 2) {
        const nextElements = elements.map((el) => {
          if (el.id === element.id) {
            return newElementWith(el, { isDeleted: true });
          }
          return el;
        });
        const nextAppState = handleGroupEditingState(appState, nextElements);


        return {
          elements: nextElements,
          appState: {
            ...nextAppState,
            editingLinearElement: null,
          },
          commitToHistory: false,
        };
      }

      // We cannot do this inside `movePoint` because it is also called
      // when deleting the uncommitted point (which hasn't caused any binding)
      const binding = {
        startBindingElement: selectedPointsIndices?.includes(0)
          ? null
          : startBindingElement,
        endBindingElement: selectedPointsIndices?.includes(
          element.points.length - 1,
        )
          ? null
          : endBindingElement,
      };

      LinearElementEditor.deletePoints(element, selectedPointsIndices);

      return {
        elements,
        appState: {
          ...appState,
          editingLinearElement: {
            ...appState.editingLinearElement,
            ...binding,
            selectedPointsIndices:
              selectedPointsIndices?.[0] > 0
                ? [selectedPointsIndices[0] - 1]
                : [0],
          },
        },
        commitToHistory: true,
      };
    }
    let { elements: nextElements, appState: nextAppState } =
        deleteSelectedElements(elements, appState,app);

    // 删除元素后，找到绑定的线和箭头，将他们也删除
    const deletedElements = elements.filter(
        ({ id }) => appState.selectedElementIds[id],
    );
    // 获取绑定更新信息，而不是直接修改元素
    const bindingUpdates = getBindingUpdatesAfterDeletion(nextElements, deletedElements);

    nextAppState = handleGroupEditingState(nextAppState, nextElements);
    // 收集需要删除的线性元素ID
    const linearElementIdsToDelete = new Set<string>();
    deletedElements.forEach((element) => {
      const { boundElements } = element;
      if (!boundElements) {
        return;
      }
      const boundIsLinearElements = boundElements.filter((boundedElement) =>
          isLinearElementType(boundedElement.type),
      );

      boundIsLinearElements.forEach((item) => {
        linearElementIdsToDelete.add(item.id);
        const currentElement = nextElements.find((iten) => iten.id === item.id);
        if (currentElement) {
          const { boundElements } = currentElement;
          if (boundElements) {
            boundElements.forEach((boundItem) => {
              linearElementIdsToDelete.add(boundItem.id);
            });
          }
        }
      });
    });

    // 使用 newElementWith 创建新的元素数组，而不是直接修改元素
    // 同时应用绑定更新
    nextElements = nextElements.map((el) => {
      const bindingUpdate = bindingUpdates.get(el.id);
      if (linearElementIdsToDelete.has(el.id) && !el.isDeleted) {
        return newElementWith(el, { isDeleted: true, ...bindingUpdate });
      }
      if (bindingUpdate) {
        return newElementWith(el, bindingUpdate);
      }
      return el;
    });

    return {
      elements: nextElements,
      appState: {
        ...nextAppState,
        activeTool: updateActiveTool(appState, { type: "selection" }),
        multiElement: null,
        activeEmbeddable: null,
      },
      commitToHistory: isSomeElementSelected(
        getNonDeletedElements(elements),
        appState,
      ),
    };
  },
  contextItemLabel: "labels.delete",
  keyTest: (event, appState, elements) => {
    if (appState.activeMindMap?.state === "hover") {
      return false;
    }
    return (
        (event.key === KEYS.BACKSPACE || event.key === KEYS.DELETE) &&
        !event[KEYS.CTRL_OR_CMD]
    );
  },
  PanelComponent: ({ elements, appState, updateData }) => (
    <ToolButton
      type="button"
      icon={TrashIcon}
      title={t("labels.delete")}
      aria-label={t("labels.delete")}
      onClick={() => updateData(null)}
      visible={isSomeElementSelected(getNonDeletedElements(elements), appState)}
    />
  ),
});
